module.exports = __webpack_public_path__ + "assets/img/swiper-3-1.e22bd45c.jpg";